import React, { useCallback, useState } from "react";
import DefaultCalendar, { CalendarProps } from "react-calendar";
import { addMonths, format } from "date-fns";
import { observer } from "mobx-react";

import Header from "./Header";

import { CalendarContainer } from "./styles";

interface Props extends CalendarProps {
  markedDates?: any;
  headerFontSize?: number;
  onChangeMonth?: (date: Date) => void;
}

const Calendar = observer((props: Props) => {
  const { value = new Date(), headerFontSize = 18, ...calendarRest } = props;
  const [activeStartDate, setActiveStartDate] = useState(() => new Date());

  const onNext = useCallback(() => {
    setActiveStartDate((prev) => {
      const next = addMonths(prev, 1);
      props.onChangeMonth?.(next);
      return next;
    });
  }, [props.onChangeMonth]);

  const onPrev = useCallback(() => {
    setActiveStartDate((prev) => {
      const next = addMonths(prev, -1);
      props.onChangeMonth?.(next);
      return next;
    });
  }, [props.onChangeMonth]);

  const setClass = useCallback(
    (date: Date) => {
      const { markedDates = {} } = props;

      let className = "";

      for (const markedDate in markedDates) {
        const currentDate = format(date, "yyyy-MM-dd");
        if (currentDate === markedDate) {
          className = markedDates[markedDate].completed
            ? "completed"
            : "scheduled";

          className += markedDates[markedDate].startingDay
            ? " startingDay"
            : "";
          className += markedDates[markedDate].endingDay ? " endingDay" : "";
        }
      }

      return className;
    },
    [props.markedDates]
  );

  return (
    <CalendarContainer>
      <Header
        date={activeStartDate}
        onNextClick={onNext}
        onPrevClick={onPrev}
        fontSize={headerFontSize}
        locale={props.locale || "en"}
      />
      <DefaultCalendar
        activeStartDate={activeStartDate}
        showNavigation={false}
        showNeighboringMonth={false}
        value={value}
        locale={props.locale || "en"}
        tileClassName={({ date }) => setClass(date)}
        tileContent={() => (
          <>
            <div className={"calendarCircle"}></div>
            <div className={"today"}></div>
            <div className={"hoverCalendarCircle"}></div>
          </>
        )}
        {...(calendarRest as CalendarProps)}
      />
    </CalendarContainer>
  );
});

export default Calendar;
